import Login from '@/locale/TH/login/login';
import Warehouse from '@/locale/TH/inventory/warehouse';
import CategoryProduct from '@/locale/TH/product/categoryProduct';
import ChannelSale from '@/locale/TH/channel/social';
import Customer from '@/locale/TH/customer/customer';
import Product from '@/locale/TH/product/product';
import Order from '@/locale/TH/order/order';
import User from '@/locale/TH/user/user';
import Provider from '@/locale/TH/provider/provider';

export default {
  th: {
    translation: {
      ...Login,
      ...Warehouse,
      ...CategoryProduct,
      ...ChannelSale,
      ...Customer,
      ...Product,
      ...Order,
      ...User,
      ...Provider
    }
  }
};
